// src/store/useSpeakCountStore.js
import { create } from 'zustand';

const useSpeakCountStore = create((set, get) => ({
    items: [],
    addItem: (item) => set((state) => ({ items: [...state.items, item] })),
    removeItem: (index) => set((state) => ({
      items: state.items.filter((_, i) => i !== index)
    })),
    getItems: () => get().items,
  }));

export default useSpeakCountStore;
